const getInputSelection = (input) => {
	let start = 0, end = 0;
	input.focus();

	if (typeof input.selectionStart == "number" &&
        typeof input.selectionEnd == "number") {

		start = input.selectionStart;
		end = input.selectionEnd;

	} else if (document.selection && document.selection.createRange) {
		const range = document.selection.createRange();

		if (range) {
			const inputRange = input.createTextRange();
			const workingRange = inputRange.duplicate();
			const bookmark = range.getBookmark();
			inputRange.moveToBookmark(bookmark);
			workingRange.setEndPoint("EndToEnd", inputRange);
			end = workingRange.text.length;
			workingRange.setEndPoint("EndToStart", inputRange);
			start = workingRange.text.length;
		}
	}
	return {
		start: start,
		end: end,
		length: end - start
	};
}

export default getInputSelection;
